import { getObjectUtil } from 'packages/src'
import REDUX_STATUS from '../../constants/status'

export default function isSavingReduxUtil (instance) {
  return getObjectUtil(instance, 'status') === REDUX_STATUS.SAVING
}
